  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
//-----------------------------
// @material-ui/core components
//-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import ButtonGroup                                         from '@material-ui/core/ButtonGroup';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
//import ListItemText                                        from '@material-ui/core/ListItemText';
//import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
  import Divider                                             from '@material-ui/core/Divider';
//import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
//import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
  //[FAB]
  import Fab                                                 from '@material-ui/core/Fab';
  import CallIcon                                            from '@material-ui/icons/Call';
//import NavigationIcon                                      from '@material-ui/icons/Navigation';
  import CloseIcon                                           from '@material-ui/icons/Close';
  import IconButton                                          from '@material-ui/core/IconButton';
  import DirectionsIcon                                      from '@material-ui/icons/Directions';
//import Accordion                                           from '@material-ui/core/Accordion';
//import AccordionDetails                                    from '@material-ui/core/AccordionDetails';
//import AccordionSummary                                    from '@material-ui/core/AccordionSummary';
//import AccordionActions                                    from '@material-ui/core/AccordionActions';
//import ExpandMoreIcon                                      from '@material-ui/icons/ExpandMore';
//import Typography                                          from '@material-ui/core/Typography';
//import Radio                                               from '@material-ui/core/Radio';
//import RadioGroup                                          from '@material-ui/core/RadioGroup';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
  import GoogleMapsContainer                                 from "components/GoogleMapsContainer/GoogleMapsContainer.jsx";
  import GoogleMapsAutocomplete                              from "components/GoogleMapsAutocomplete/GeocodingsAutocomplete";
  //--------------------
  // 3rd party libraries
  //--------------------
  import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_Locations }                                    from "../../_services";
  import { wu_GeolocationService }                           from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
  //------
  // Style
  //------
  import StoreLocatorStyle                                   from "./StoreLocatorStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import logo_wu                                             from "assets/img/wu/maps/logo-wu.png";
//import logo_gc                                             from "assets/img/wu/maps/logo-gocash.png";
  import logo_wu_SVG                                         from "assets/img/wu/maps/logo-wu.svg";
//import logo_gc_SVG                                         from "assets/img/wu/maps/logo-gocash.svg";
  import logo_gc_SVG                                         from "assets/img/wu/maps/bill_payment.svg";
  //[Campaign]
  import WU_popup_campaign_el                                from "assets/img/wu/popup_campaign_el.png";
  import WU_popup_campaign_en                                from "assets/img/wu/popup_campaign_en.png";
  //----------
  // variables
  //----------
  const filename = "StoreLocator ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const AUTOCOMPLETE_MIN_CHARACTERS_OPEN_POPUP = 3;       //
  const AUTOCOMPLETE_FILTER_OPTIONS            = "start"; //"start","any"
  const AUTOCOMPLETE_KEYWORDS_LANG_ALL         = true;    //true=greek and english together

  const AUTOCOMPLETE_HAS_prefecture_name       = false;   //true-Attica, Αττικής
  const AUTOCOMPLETE_HAS_sub_prefecture_name   = false;   //West Sector of Athens, Δυτικού Τομέα Αθηνών
  const AUTOCOMPLETE_HAS_municipal_name        = false;   //Peristeri, Περιστερίου
  const AUTOCOMPLETE_HAS_locale_name           = false;   //true-Peristeri, Περιστέρι
  const AUTOCOMPLETE_HAS_addr                  = false;   //LEOF. PANAGI TSALDARI 17 &  DIMITRAKOPOULOU 2, ΛΕΩΦ. ΠΑΝΑΓΗ ΤΣΑΛΔΑΡΗ 17 & ΔΗΜΗΤΡΑΚΟΠΟΥΛΟΥ
  const AUTOCOMPLETE_HAS_city                  = false;   //true-Peristeri, Περιστέρι
  const AUTOCOMPLETE_HAS_zone_name             = false;   //true-Athina - Dytikos Tomeas, Αθήνα - Δυτικός Τομέας xxx
  const AUTOCOMPLETE_HAS_subzone_name          = false;   //true-Agioi Taxiarches Peristeriou, Άγιοι Ταξιάρχες Περιστερίου

  const AUTOCOMPLETE_KEYWORDS_KEYS_ALL         = [
    "loc_name",
    "post_code",
  /*"sa_name",*/
  //   "prefecture_name_en",            "prefecture_name_el",
  // /*"sub_prefecture_name_en",*/    /*"sub_prefecture_name_el",*/
  // /*"municipal_name_en",*/         /*"municipal_name_el",*/
  //   "locale_name_en",                "locale_name_el",
  // /*"addr_en",*/                   /*"addr_el",*/
  //   "city_en",                       "city_el",
  // /*"zone_name_en",*/              /*"zone_name_el",*/
  //   "subzone_name_en",               "subzone_name_el"
  ];
  const AUTOCOMPLETE_KEYWORDS_KEYS_EN          = [
      "loc_name",
      "post_code",
    /*"sa_name",*/
    //   "prefecture_name_en",        /*"prefecture_name_el",*/
    // /*"sub_prefecture_name_en",*/  /*"sub_prefecture_name_el",*/
    // /*"municipal_name_en",*/       /*"municipal_name_el",*/
    //   "locale_name_en",            /*"locale_name_el",*/
    // /*"addr_en",*/                 /*"addr_el",*/
    //   "city_en",                   /*"city_el",*/
    // /*"zone_name_en",*/            /*"zone_name_el",*/
    //   "subzone_name_en",           /*"subzone_name_el"*/
  ];
  const AUTOCOMPLETE_KEYWORDS_KEYS_EL          = [
      "loc_name",
      "post_code",
    /*"sa_name",*/
    // /*"prefecture_name_en",*/        "prefecture_name_el",
    // /*"sub_prefecture_name_en",*/  /*"sub_prefecture_name_el",*/
    // /*"municipal_name_en",*/       /*"municipal_name_el",*/
    // /*"locale_name_en",*/            "locale_name_el",
    // /*"addr_en",*/                 /*"addr_el",*/
    // /*"city_en",*/                   "city_el",
    // /*"zone_name_en",*/            /*"zone_name_el",*/
    // /*"subzone_name_en",*/           "subzone_name_el"
  ];
  if(AUTOCOMPLETE_HAS_prefecture_name)    {AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("prefecture_name_en");     AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("prefecture_name_el");     AUTOCOMPLETE_KEYWORDS_KEYS_EN.push("prefecture_name_en");     AUTOCOMPLETE_KEYWORDS_KEYS_EL.push("prefecture_name_el"); }
  if(AUTOCOMPLETE_HAS_sub_prefecture_name){AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("sub_prefecture_name_en"); AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("sub_prefecture_name_el"); AUTOCOMPLETE_KEYWORDS_KEYS_EN.push("sub_prefecture_name_en"); AUTOCOMPLETE_KEYWORDS_KEYS_EL.push("sub_prefecture_name_el");}
  if(AUTOCOMPLETE_HAS_municipal_name)     {AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("municipal_name_en");      AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("municipal_name_el");      AUTOCOMPLETE_KEYWORDS_KEYS_EN.push("municipal_name_en");      AUTOCOMPLETE_KEYWORDS_KEYS_EL.push("municipal_name_el");}
  if(AUTOCOMPLETE_HAS_locale_name)        {AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("locale_name_en");         AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("locale_name_el");         AUTOCOMPLETE_KEYWORDS_KEYS_EN.push("locale_name_en");         AUTOCOMPLETE_KEYWORDS_KEYS_EL.push("locale_name_el");}
  if(AUTOCOMPLETE_HAS_addr)               {AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("addr_en");                AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("addr_el");                AUTOCOMPLETE_KEYWORDS_KEYS_EN.push("addr_en");                AUTOCOMPLETE_KEYWORDS_KEYS_EL.push("addr_el");}
  if(AUTOCOMPLETE_HAS_city)               {AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("city_en");                AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("city_el");                AUTOCOMPLETE_KEYWORDS_KEYS_EN.push("city_en");                AUTOCOMPLETE_KEYWORDS_KEYS_EL.push("city_el");}
  if(AUTOCOMPLETE_HAS_zone_name)          {AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("zone_name_en");           AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("zone_name_el");           AUTOCOMPLETE_KEYWORDS_KEYS_EN.push("zone_name_en");           AUTOCOMPLETE_KEYWORDS_KEYS_EL.push("zone_name_el");}
  if(AUTOCOMPLETE_HAS_subzone_name)       {AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("subzone_name_en");        AUTOCOMPLETE_KEYWORDS_KEYS_ALL.push("subzone_name_el");        AUTOCOMPLETE_KEYWORDS_KEYS_EN.push("subzone_name_en");        AUTOCOMPLETE_KEYWORDS_KEYS_EL.push("subzone_name_el");}

class StoreLocator extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      autoCompleteSearchEnabled                            : api.autoCompleteSearchEnabled, //newSearchEnabled
      textField1b                                          : "",
      textField1b_inputValue                               : "",
      textField1b_hasError                                 : false,
    //textField1b_popoverOpen                              : false,
      textField1                                           : "",
      textField1_inputValue                                : "",
      textField1_hasError                                  : false,
      textField1_popoverOpen                               : false,

      pops_search_res                                      : [],
      initialCenter_lat                                    : 37.9615514,
      initialCenter_lon                                    : 23.7333268,
      initialZoom                                          : 8,
      dialog2_msg                                          : "",
      dialog2_isOpen                                       : false,
      showingInfoWindow                                    : false,

      dialog3_msg                                          : "",
      dialog3_isOpen                                       : false,

      dialogS_msg                                          : "",
      dialogS_isOpen                                       : false,

      StoreLocator_btn_WU_isActive                         : true,   showWUStores                                         : true,
      StoreLocator_btn_BP_isActive                         : false,  showBPStores                                         : false,
      StoreLocator_btn_map_isActive                        : false,  showResultsOnMap                                     : false,
      StoreLocator_btn_openTodayAfternoon_isActive         : false,
      StoreLocator_btn_openNow_isActive                    : false,
      StoreLocator_btn_sunday_isActive                     : false,

      searchUsingTimetable                                 : false,
      timetableValue                                       : "", //"openNow","openTodayAfternoon","sunday"
      searchNearest                                        : false,
      searchAddress                                        : false,

      parserObject_getLocations                            : [],

      showGoogleMapFix                                        : true,
      loadGoogleMapFix                                        : false,

      //popup checkAppVersion
      dialog_checkAppVersion_isOpen                        : false,
      dialog_checkAppVersion_msg                           : "",

      //[FAB]
      fab_isHidden                                         : true,
      dialog100_msg                                        : "",
      dialog100_isOpen                                     : false,

      //[Campaign]
      dialog101_msg                                        : "",
      dialog101_isOpen                                     : false,
      dialog101_campaign_image_w                           : "512",
      dialog101_campaign_image_h                           : "268",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.dialogS_handleClose_nearest                                 = this.dialogS_handleClose_nearest.bind(this);
    this.dialogS_handleClose_newSearch                               = this.dialogS_handleClose_newSearch.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                        = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                       = this.dialog200_handleClose.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);


    this.StoreLocator_btn_search_with_enter                          = this.StoreLocator_btn_search_with_enter.bind(this);
    this.StoreLocator_btn_search                                     = this.StoreLocator_btn_search.bind(this);
    this.StoreLocator_btn_nearest                                    = this.StoreLocator_btn_nearest.bind(this);
    this.StoreLocator_btn_search_isDisabled                          = this.StoreLocator_btn_search_isDisabled.bind(this);
    this.StoreLocator_btn_nearest_isDisabled                         = this.StoreLocator_btn_nearest_isDisabled.bind(this);

    this.StoreLocator_btn_WU                                         = this.StoreLocator_btn_WU.bind(this);
    this.StoreLocator_btn_BP                                         = this.StoreLocator_btn_BP.bind(this);
    this.StoreLocator_btn_map                                        = this.StoreLocator_btn_map.bind(this);
    this.StoreLocator_btn_openTodayAfternoon                         = this.StoreLocator_btn_openTodayAfternoon.bind(this);
    this.StoreLocator_btn_openNow                                    = this.StoreLocator_btn_openNow.bind(this);
    this.StoreLocator_btn_sunday                                     = this.StoreLocator_btn_sunday.bind(this);

    this.handleCheckBoxClick_mapOrList                               = this.handleCheckBoxClick_mapOrList.bind(this);
    this.handleCheckBoxClick_BillsorNot                              = this.handleCheckBoxClick_BillsorNot.bind(this);
    this.handleCheckBoxClick_WUorNot                                 = this.handleCheckBoxClick_WUorNot.bind(this);
    this.handleCheckBoxClick_Timetable                               = this.handleCheckBoxClick_Timetable.bind(this);

    this.dialog2_handleClose                                         = this.dialog2_handleClose.bind(this);

    this.dialog3_handleClose                                         = this.dialog3_handleClose.bind(this);
    this.get_index_FromObj                                           = this.get_index_FromObj.bind(this);
    this.get_name_FromObj                                            = this.get_name_FromObj.bind(this);
    this.get_address_FromObj                                         = this.get_address_FromObj.bind(this);
    this.get_postcode_FromObj                                        = this.get_postcode_FromObj.bind(this);
    this.get_localename_FromObj                                      = this.get_localename_FromObj.bind(this);
    this.get_gm_latitude_FromObj                                     = this.get_gm_latitude_FromObj.bind(this);
    this.get_gm_longitude_FromObj                                    = this.get_gm_longitude_FromObj.bind(this);
    this.get_timetable_FromObj                                       = this.get_timetable_FromObj.bind(this);
    this.get_isOpenNow_FromObj                                       = this.get_isOpenNow_FromObj.bind(this);
    this.get_isOpenNow_FromObj_Color                                 = this.get_isOpenNow_FromObj_Color.bind(this);
    this.get_phone_FromObj                                           = this.get_phone_FromObj.bind(this);
    this.show_WU_image                                               = this.show_WU_image.bind(this);
    this.show_GC_image                                               = this.show_GC_image.bind(this);

    this.canPayBill                                                  = this.canPayBill.bind(this);
    this.canTransferWU                                               = this.canTransferWU.bind(this);

    this.updateParentInitialLatLon                                   = this.updateParentInitialLatLon.bind(this);
    this.updateParentInitialLatLonZoom                               = this.updateParentInitialLatLonZoom.bind(this);
    this.update_showingInfoWindow                                    = this.update_showingInfoWindow.bind(this);

    this.handleRadioButtonClick_timetable                            = this.handleRadioButtonClick_timetable.bind(this);

    this.Directions_list_act                                         = this.Directions_list_act.bind(this);

    this.handleCustomDropDownClick_term                              = this.handleCustomDropDownClick_term.bind(this);
    this.handleCustomDropDownClick_term_close                        = this.handleCustomDropDownClick_term_close.bind(this);

    this.GoogleMapsAutocomplete_handleClick                          = this.GoogleMapsAutocomplete_handleClick.bind(this);
    this.GoogleMapsAutocomplete_onInputChange                        = this.GoogleMapsAutocomplete_onInputChange.bind(this);

    //popup checkAppVersion
    this.dialog_checkAppVersion_handleOpen                           = this.dialog_checkAppVersion_handleOpen.bind(this);
    this.dialog_checkAppVersion_btn_ok                               = this.dialog_checkAppVersion_btn_ok.bind(this);

    //[FAB]
    this.fab_geoLocateIP                                             = this.fab_geoLocateIP.bind(this);
    this.fab_Click2CallAction                                        = this.fab_Click2CallAction.bind(this);
    this.dialog100_handleOpen                                        = this.dialog100_handleOpen.bind(this);
    this.dialog100_handleClose                                       = this.dialog100_handleClose.bind(this);

    //[CAMPAIGN]
    this.dialog101_handleOpen                                        = this.dialog101_handleOpen.bind(this);
    this.dialog101_handleClose                                       = this.dialog101_handleClose.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        //++++++++++++
        //Login Screen
        //++++++++++++
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    let window_CookieBot_loaded = localStorage.getItem("window_CookieBot_loaded")==="true" ? "true" : "false";
    let initial_aux_timeout     = 0;//window_CookieBot_loaded==="true" ? 5000 : 5000;
    console.log(methName+this.getCompactDateTime()+" window_CookieBot_loaded = "+window_CookieBot_loaded);
    console.log(methName+this.getCompactDateTime()+" initial_aux_timeout     = "+initial_aux_timeout);
    //-------------
    //Do some reset
    //-------------
    this.clear_cardpayment_transfer_cookies();
    this.clear_cardpayment_bill_cookies();
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}
    try { localStorage.setItem("CustomerWantedToLoginToBills", "false"); } catch(err){;}

    //nailed for testing:START---inactive
    //localStorage.removeItem("locations");
    //nailed for TESTING:END
    //---------------
    //wu_getLocations---CACHED
    //---------------
    let retrieveWSData_getLocations = wu_Locations.wu_should_getLocations();
    if(retrieveWSData_getLocations){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen();} //start DialogSpinner only if network connection will take place
      wu_Locations
      .wu_getLocations({})
      .then(res => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        this.setState({ "parserObject_getLocations": res.locations });
        if(AUTOCOMPLETE_KEYWORDS_LANG_ALL===true){
          let getLocations_keywords_vals_all = wu_Utilities.extractKeywordsFromJSON(res.locations,AUTOCOMPLETE_KEYWORDS_KEYS_ALL);
          console.log(methName+'(1)');//console.log(methName+'(1)getLocations_keywords_vals_all='+getLocations_keywords_vals_all.length+'=>'+getLocations_keywords_vals_all);
          this.setState({ "getLocations_keywords_vals_all": getLocations_keywords_vals_all });
        }
        else{
          let getLocations_keywords_vals_en = wu_Utilities.extractKeywordsFromJSON(res.locations,AUTOCOMPLETE_KEYWORDS_KEYS_EN);
          //console.log(methName+'getLocations_keywords_vals_en='+getLocations_keywords_vals_en.length+'=>'+getLocations_keywords_vals_en);
          this.setState({ "getLocations_keywords_vals_en": getLocations_keywords_vals_en });
          let getLocations_keywords_vals_el = wu_Utilities.extractKeywordsFromJSON(res.locations,AUTOCOMPLETE_KEYWORDS_KEYS_EL);
          //console.log(methName+'getLocations_keywords_vals_el='+getLocations_keywords_vals_el.length+'=>'+getLocations_keywords_vals_el);
          this.setState({ "getLocations_keywords_vals_el": getLocations_keywords_vals_el });
        }
        setTimeout(function() { this.checkAppVersion(); }.bind(this), initial_aux_timeout);//this.checkAppVersion();
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getLocations="+retrieveWSData_getLocations);}
        console.log(methName+"err1="+err);
        let res = wu_StaticDataService.wu_get_cached_locations({});
        this.setState({ "parserObject_getLocations": res.locations });
        if(AUTOCOMPLETE_KEYWORDS_LANG_ALL===true){
          let getLocations_keywords_vals_all = wu_Utilities.extractKeywordsFromJSON(res.locations,AUTOCOMPLETE_KEYWORDS_KEYS_ALL);
          console.log(methName+'(2)');//console.log(methName+'(2)getLocations_keywords_vals_all='+getLocations_keywords_vals_all.length+'=>'+getLocations_keywords_vals_all);
          this.setState({ "getLocations_keywords_vals_all": getLocations_keywords_vals_all });
        }
        else{
          let getLocations_keywords_vals_en = wu_Utilities.extractKeywordsFromJSON(res.locations,AUTOCOMPLETE_KEYWORDS_KEYS_EN);
          //console.log(methName+'getLocations_keywords_vals_en='+getLocations_keywords_vals_en.length+'=>'+getLocations_keywords_vals_en);
          this.setState({ "getLocations_keywords_vals_en": getLocations_keywords_vals_en });
          let getLocations_keywords_vals_el = wu_Utilities.extractKeywordsFromJSON(res.locations,AUTOCOMPLETE_KEYWORDS_KEYS_EL);
          //console.log(methName+'getLocations_keywords_vals_el='+getLocations_keywords_vals_el.length+'=>'+getLocations_keywords_vals_el);
          this.setState({ "getLocations_keywords_vals_el": getLocations_keywords_vals_el });
        }
        setTimeout(function() { this.checkAppVersion(); }.bind(this), initial_aux_timeout);//this.checkAppVersion();
      });
    }
    else{
      try{
        let res = JSON.parse(localStorage.getItem("locations"));
        this.setState({ "parserObject_getLocations": res.locations });
        if(AUTOCOMPLETE_KEYWORDS_LANG_ALL===true){
          let getLocations_keywords_vals_all = wu_Utilities.extractKeywordsFromJSON(res.locations,AUTOCOMPLETE_KEYWORDS_KEYS_ALL);
          console.log(methName+'(1)');//console.log(methName+'(3)getLocations_keywords_vals_all='+getLocations_keywords_vals_all.length+'=>'+getLocations_keywords_vals_all);
          this.setState({ "getLocations_keywords_vals_all": getLocations_keywords_vals_all });
        }
        else{
          let getLocations_keywords_vals_en = wu_Utilities.extractKeywordsFromJSON(res.locations,AUTOCOMPLETE_KEYWORDS_KEYS_EN);
          //console.log(methName+'getLocations_keywords_vals_en='+getLocations_keywords_vals_en.length+'=>'+getLocations_keywords_vals_en);
          this.setState({ "getLocations_keywords_vals_en": getLocations_keywords_vals_en });
          let getLocations_keywords_vals_el = wu_Utilities.extractKeywordsFromJSON(res.locations,AUTOCOMPLETE_KEYWORDS_KEYS_EL);
          //console.log(methName+'getLocations_keywords_vals_el='+getLocations_keywords_vals_el.length+'=>'+getLocations_keywords_vals_el);
          this.setState({ "getLocations_keywords_vals_el": getLocations_keywords_vals_el });
        }
        setTimeout(function() { this.checkAppVersion(); }.bind(this), initial_aux_timeout);//this.checkAppVersion();
      }catch(err){
        console.log(methName+"err2="+err);
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")+"(err002)"); }
      }
    }

    //[CAMPAIGN]
    //wu_Utilities.campaign_clear_statsView(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,filename.trim());
    wu_Utilities.campaign_record_load(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim());
    if(wu_Utilities.campaign_should_show(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim())===true){
      if(window){
        console.log("campaigns window.innerWidth="+window.innerWidth);
        if(window.innerWidth > 960){ this.setState({"dialog101_campaign_image_w":"512","dialog101_campaign_image_h":"268",}); }
        else                       { this.setState({"dialog101_campaign_image_w":"256","dialog101_campaign_image_h":"134",}); }
        this.dialog101_handleOpen("");
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  checkAppVersion(){
    let methName = filename+"checkAppVersion ";
    if(api.print_logs){console.log(methName);}

    //---------------
    //checkAppVersion---CACHED
    //---------------
    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    let retrieveWSData_checkAppVersion = wu_AppVersion.wu_should_checkAppVersion();
    if(retrieveWSData_checkAppVersion){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_AppVersion
      .wu_checkAppVersion(parserObject_checkAppVersion_req)
      .then(res => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        if(res.isMajorUpdate===true){
          this.dialog_checkAppVersion_handleOpen(res.returnText);
          return;
        }
        //[FAB]
        setTimeout(function() { this.fab_geoLocateIP(); }.bind(this), 200);//this.fab_geoLocateIP();
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        //[FAB]
        setTimeout(function() { this.fab_geoLocateIP(); }.bind(this), 200);//this.fab_geoLocateIP();
      });
    }
    else{
      try{
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        //[FAB]
        setTimeout(function() { this.fab_geoLocateIP(); }.bind(this), 200);//this.fab_geoLocateIP();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //[FAB]
  fab_geoLocateIP(){
    let methName = filename+"fab_geoLocateIP ";
    if(api.print_logs){console.log(methName);}

    //SOS TODO cache for a certain period
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.setState({ "fab_isHidden":false }); return; }
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    let phonePrefixes = wu_StaticDataService.wu_getPhonePrefixes({});

    this.startSpinners();
    //--------------
    //wu_geolocation
    //--------------
    wu_GeolocationService
    .wu_geolocation({}) //FAB
    .then(res => {
      localStorage.setItem("parserObject_geolocation",JSON.stringify(res.location));
      let ws_country = "";
      try {ws_country = res.location["country"]; }catch(err){;} if(ws_country === null || (typeof ws_country ==="undefined")){ws_country = "";}
      for(let i=0; i<phonePrefixes.phone_prefixes.length; ++i){
        if(phonePrefixes.phone_prefixes[i]["descr"].indexOf(ws_country)>=0){
          localStorage.setItem("IPCOUNTRY",           phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          localStorage.setItem("UserSelectedCountry", phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          break;
        }
      }
      console.log(methName+"IPCOUNTRY="+localStorage.getItem("IPCOUNTRY"));
      if(localStorage.getItem("IPCOUNTRY")!==""){this.setState({ "fab_isHidden":false });}
    })
    .catch(err => {
      this.stopSpinners();
      console.log(methName+'err='+err);
      //this.dialog_handleOpen(this.NSInforString("networkerror")+"(err003)");
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
      function (position) {
        console.log(methName+"navigator.geolocation.getCurrentPosition SUCCESS");
        localStorage.setItem("gpslat",""+position.coords.latitude);  console.log(methName+"lat="+position.coords.latitude);
        localStorage.setItem("gpslon",""+position.coords.longitude); console.log(methName+"lon="+position.coords.longitude);
      },
      function (error) {
        console.log(methName+"navigator.geolocation.getCurrentPosition FAILURE");
        if(error.code === error.PERMISSION_DENIED) {
          localStorage.setItem("gpslat",""); console.log(methName+"lat=");
          localStorage.setItem("gpslon",""); console.log(methName+"lon=");
        }
      }
      );
    }

    // let t1 = {timetableEN:"Mon-Fri: 09:00 - 15:00"};
    // let t2 = {timetableEN:"Mon-Fri: 09:00 - 15:00;17:00 - 20:00, Sat: 09:00 - 15:00"};
    // let t3 = {timetableEN:"Mon-Fri: 09:00 - 15:00;17:00 - 21:00, Sat: 10:00 - 15:00"};
    // let t4 = {timetableEN:"Mon-Fri: 09:00 - 15:00;17:00 - 21:30, Sat: 09:00 - 14:00"};
    // let t5 = {timetableEN:"Mon-Fri: 09:00 - 15:00;17:30 - 21:30, Sat: 09:00 - 14:00;17:30 - 21:30, Sun: 18:00 - 21:00"};
    // let t6 = {timetableEN:"Mon-Fri: 09:00 - 15:00;17:30 - 23:30, Sat: 08:00 - 14:00, Sun: 18:00 - 21:00"};
    // let timetableFilteringRes = wu_Utilities.timetableFiltering(t4,"openTodayAfternoon");
    // console.log("timetableEN="+t4.timetableEN+",openTodayAfternoon=>"+timetableFilteringRes);

    //----------------------
    //Criteo Event Recording
    //----------------------
    let shouldUseCriteo = api.shouldUseCriteo;
    if(shouldUseCriteo===true && api.webappENV==="PROD"){
      try {
        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        window.criteo_q.push(
         { event: "setAccount", account: api.criteo_account }, // You should never update this line
         { event: "setEmail", email: "" },                  // Can be an empty string
         { event: "setSiteType", type: deviceType},
         { event: "trackTransaction", id: Math.floor(Math.random()*99999999999)+1, item: [{id:"1", price:1, quantity:1}] }
        );
      }catch(err0){console.log(methName+"err0="+err0);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

  //let tmp_w = localStorage.getItem("mobileOpen")==="true" ? '310px' : "600px";
  //let tmp_h = localStorage.getItem("mobileOpen")==="true" ? '500px' : "500px";
    let tmp_w = window && window.innerWidth >= 960 ? "600px" : '310px';
    let tmp_h = window && window.innerWidth >= 960 ? "410px" : '410px';
    let divStyle = { "overflow-x":"hidden", width:tmp_w, height:tmp_h };

    console.log(methName);
    let defaultPropsCountry = {};
    if(AUTOCOMPLETE_KEYWORDS_LANG_ALL===true){
      defaultPropsCountry = {
        options        : this.state.getLocations_keywords_vals_all,
        getOptionLabel : option => option,
      };
    }
    else{
      defaultPropsCountry = {
        options        : localStorage.getItem("lang")==="en" ? this.state.getLocations_keywords_vals_en : this.state.getLocations_keywords_vals_el,
        getOptionLabel : option => option,
      };
    }

    const filterOptions = createFilterOptions({
      matchFrom: AUTOCOMPLETE_FILTER_OPTIONS,
      stringify: option => option,
    });
    console.log(methName+"SOS before return");

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          {/* [FAB] */}
          {this.state.fab_isHidden === true ? ( "" ) : (
            <Fab color="primary" aria-label="add" onClick={this.fab_Click2CallAction} className={classes.fab}>
              <CallIcon />
            </Fab>
          )}
          <GridItem xs={12} sm={6} md={6}>

            <div style={{ marginTop: 25 }}>
              <div className={classes.labelHeader}>{this.NSInforString("StoreLocator_title")}</div>
              <div className={classes.logo}><img src={logo} alt="logo" /></div>
            </div>

            <GridContainer justify="center">
              {/* ------------------------------- */}
              {/* ----------Label---------------- */}
              {/* ------------------------------- */}
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.StoreLocator_lbl_info}><b>{this.NSInforString("StoreLocator_lbl_info")}</b></div>
              </GridItem>
              {/* ------------------------------- */}
              {/* ----------3 Buttons------------ */}
              {/* ------------------------------- */}
              <GridItem xs={12} sm={12} md={12} style={{"textAlign": "center"}}>
                <CustomButton
                  disabled={false}
                  className={this.state.StoreLocator_btn_WU_isActive ? classes.optionButton_active : classes.optionButton_inactive}
                  color="rose"
                  onClick={this.StoreLocator_btn_WU}
                  type="submit">
                  {this.NSInforString("StoreLocator_btn_WU")}
                </CustomButton>
                <CustomButton
                  disabled={false}
                  className={this.state.StoreLocator_btn_BP_isActive ? classes.optionButton_active : classes.optionButton_inactive}
                  color="rose"
                  onClick={this.StoreLocator_btn_BP}
                  type="submit">
                  {this.NSInforString("StoreLocator_btn_BP")}
                </CustomButton>
                {this.state.showGoogleMapFix===true ? (
                <CustomButton
                  disabled={false}
                  className={this.state.StoreLocator_btn_map_isActive ? classes.optionButton_active : classes.optionButton_inactive}
                  color="rose"
                  onClick={this.StoreLocator_btn_map}
                  type="submit">
                  {this.NSInforString("StoreLocator_btn_map")}
                </CustomButton>
                ) : ( "" )}
              </GridItem>
              <div style={{ marginTop: 50 }}>
              </div>
              {/* ------------------------------- */}
              {/* ----------3 Buttons------------ */}
              {/* ------------------------------- */}
              <GridItem xs={12} sm={12} md={12} style={{"textAlign": "center"}}>
                <CustomButton
                  disabled={false}
                  className={this.state.StoreLocator_btn_openTodayAfternoon_isActive ? classes.optionButton_active : classes.optionButton_inactive}
                  color="rose"
                  onClick={this.StoreLocator_btn_openTodayAfternoon}
                  type="submit">
                  {this.NSInforString("StoreLocator_btn_openTodayAfternoon")}
                </CustomButton>
                <CustomButton
                  disabled={false}
                  className={this.state.StoreLocator_btn_openNow_isActive ? classes.optionButton_active : classes.optionButton_inactive}
                  color="rose"
                  onClick={this.StoreLocator_btn_openNow}
                  type="submit">
                  {this.NSInforString("StoreLocator_btn_openNow")}
                </CustomButton>
                <CustomButton
                  disabled={false}
                  className={this.state.StoreLocator_btn_sunday_isActive ? classes.optionButton_active : classes.optionButton_inactive}
                  color="rose"
                  onClick={this.StoreLocator_btn_sunday}
                  type="submit">
                  {this.NSInforString("StoreLocator_btn_sunday")}
                </CustomButton>
              </GridItem>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={6}>
                <div className={classes.StoreLocator_lbl_info3}>{this.NSInforString("StoreLocator_plh1b_h")}</div>
                <GoogleMapsAutocomplete textField1b_hasError={this.state.textField1b_hasError} textField1b_inputValue={this.state.textField1b_inputValue} onChange={place => this.GoogleMapsAutocomplete_handleClick(place)} onInputChange={(newText) => this.GoogleMapsAutocomplete_onInputChange(newText)}/>
                <div id="wbwugooglemapsid"></div>
              </GridItem>
              <GridItem xs={12} sm={12} md={6} container={true} className={classes.StoreLocator_lbl_or_grid}>
                <div><span style={{ fontWeight: 500 }}>{this.NSInforString("StoreLocator_or")}</span></div>
              </GridItem>
              <GridItem xs={12} sm={12} md={6} style={{position:"relative"}}>
                <div className={classes.StoreLocator_lbl_or}><span style={{ fontWeight: 500 }}>{this.NSInforString("StoreLocator_or")}</span></div>
                <FormControl fullWidth className={classes.picker1_textFieldLabel1}>
                  <div className={classes.StoreLocator_lbl_info3}>{this.NSInforString("StoreLocator_plh1_h")}</div>
                  <Autocomplete
                    id="textField1_autocomplete"
                    onKeyPress={this.StoreLocator_btn_search_with_enter}
                    freeSolo
                    filterOptions={filterOptions}
                    {...defaultPropsCountry}
                    value={this.state.textField1}
                    inputValue={this.state.textField1_inputValue}
                    open={this.state.textField1_popoverOpen}
                    onClose={(event,value) => this.handleCustomDropDownClick_term_close(event,value)}
                    onInputChange={(event,value) => this.handleCustomDropDownClick_term(event,value)}
                    renderOption={option => {return (<React.Fragment>{option}</React.Fragment>);}}
                    renderInput={(params) => (<TextField {...params} error={this.state.textField1_hasError} label={this.NSInforString("StoreLocator_plh1")} margin="normal" variant="outlined" />)}
                  />
                </FormControl>
              </GridItem>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {/*
              <GridItem xs={12} sm={12} md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleCheckBoxClick_mapOrList}
                      value="checkedA"
                      checked={this.state.showResultsOnMap}
                      inputProps={{ 'aria-label': 'Checkbox A' }}
                    />
                  }
                  label=""
                /><span style={{fontWeight:"500"}}>{this.NSInforString("StoreLocator_lbl_checkBox")}</span>
              </GridItem> */}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {/* <GridItem xs={12} sm={12} md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleCheckBoxClick_BillsorNot}
                      value="checkedB"
                      checked={this.state.showBPStores}
                      inputProps={{ 'aria-label': 'Checkbox A' }}
                    />
                  }
                  label=""
                /><span style={{fontWeight:"500"}}>{this.NSInforString("StoreLocator_lbl_checkBoxBillPay")}</span>
              </GridItem> */}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {/* <GridItem xs={12} sm={12} md={12}>
                <Accordion elevation={0} style={{ padding:0, margin:'-10px 0 0 0'  }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1c-content"
                    id="panel1c-header" style={{ padding:0, margin: 0 }}>
                    <div className={classes.column}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={this.handleCheckBoxClick_Timetable}
                            value="checkedA"
                            checked={this.state.searchUsingTimetable}
                            inputProps={{ 'aria-label': 'Checkbox A' }}
                          />
                        }
                        label=""
                      /><span style={{fontWeight:"500"}}>{this.NSInforString("StoreLocator_lbl_checkBox_timetable")}</span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails style={{ padding:0, margin: 0 }}>
                    <RadioGroup aria-label="timetable" name="timetable1" value={this.state.timetableValue} onChange={this.handleRadioButtonClick_timetable} style={{"flex-direction":"row"}}>
                      <FormControlLabel value="openNow"            control={<Radio />} label={this.NSInforString("StoreLocator_lbl_checkBox_openNow")} />
                      <FormControlLabel value="openTodayAfternoon" control={<Radio />} label={this.NSInforString("StoreLocator_lbl_checkBox_openTodayAfternoon")} />
                      <FormControlLabel value="sunday"             control={<Radio />} label={this.NSInforString("StoreLocator_lbl_checkBox_sunday")} />
                    </RadioGroup>
                  </AccordionDetails>
                </Accordion>
              </GridItem> */}
              {/* ------------------------- */}
              {/* ----------[SPINNERS]----- */}
              {/* ------------------------- */}
              {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                </GridContainer>
              )}
              {/* ------------------------- */}
              {/* ----------[BUTTONS]------ */}
              {/* ------------------------- */}
              <GridItem xs={10} sm={10} md={10}>
                  <div style={{display:"flex", alignItems:"center", "justifyContent":"center"}}>
                    <ButtonGroup color="primary" aria-label="outlined primary button group" style={{"minWidth":"85%"}}>
                      <CustomButton
                        disabled={this.StoreLocator_btn_search_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.StoreLocator_btn_search}
                        type="submit">
                        {this.NSInforString("StoreLocator_btn_search")}
                      </CustomButton>
                      <CustomButton
                        disabled={this.StoreLocator_btn_nearest_isDisabled()}
                        className={classes.whiteButton}
                        color="rose"
                        onClick={this.StoreLocator_btn_nearest}
                        type="submit">
                        {this.NSInforString("StoreLocator_btn_nearest")}
                      </CustomButton>
                    </ButtonGroup>
                  </div>
              </GridItem>
              {/* ------------------------------- */}
              {/* ----------Label---------------- */}
              {/* ------------------------------- */}
              {/* <GridItem xs={12} sm={12} md={12}>
                <div className={classes.StoreLocator_lbl_info2}>{this.NSInforString("StoreLocator_lbl_info2")}</div>
              </GridItem> */}
            </GridContainer>
          </GridItem>
        </GridContainer>
        <div className={classes.StoreLocator_lbl_info2}>{this.NSInforString("StoreLocator_lbl_info2")}</div>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>{this.NSInforString("StoreLocator2_newSearch")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* -------------------------------------- */}
        {/* ----------[POPUP SEARCH ERROR]-------- */}
        {/* -------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialogS_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialogS_handleClose_newSearch}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialogS_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialogS_handleClose_nearest}>{this.NSInforString("StoreLocator2_showNearest")}</Button>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialogS_handleClose_newSearch}>{this.NSInforString("StoreLocator2_newSearch")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP MAP]---- */}
        {/* ------------------------- */}
        <div >
          <Dialog
            open={this.state.dialog2_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog2_handleClose}
            aria-labelledby="alert-dialog2-slide-title"
            aria-describedby="alert-dialog2-slide-description"
            classes={{paper: classes.paper}}
          >
              {this.state.loadGoogleMapFix===true ? (
              <div style={divStyle}>
                <GoogleMapsContainer
                  searchResults                 = {this.state.pops_search_res}
                  initialCenterLat              = {this.state.initialCenter_lat}
                  initialCenterLon              = {this.state.initialCenter_lon}
                  initialZoom                   = {this.state.initialZoom}
                  updateParentInitialLatLon     = {this.updateParentInitialLatLon}
                  updateParentInitialLatLonZoom = {this.updateParentInitialLatLonZoom}
                  showingInfoWindow             = {this.state.showingInfoWindow}
                  update_showingInfoWindow      = {this.update_showingInfoWindow}
                />
              </div>
              ) : ( "" )}
              {this.state.autoCompleteSearchEnabled === true ? (
                <DialogActions>
                  {localStorage.getItem("mobileOpen")==="true" ? (
                    <IconButton className={classes.customizedButton_mobile} onClick={this.dialog2_handleClose}><CloseIcon /></IconButton>
                  ) : (
                    <IconButton className={classes.customizedButton} onClick={this.dialog2_handleClose}><CloseIcon /></IconButton>
                  )}
                </DialogActions>
              ) : ( "" )}
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP LIST]--- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog3_isOpen}
            TransitionComponent={Transition}
            //keepMounted
            onClose={this.dialog3_handleClose}
            aria-labelledby="alert-dialog3-slide-title"
            aria-describedby="alert-dialog3-slide-description"
            classes={{paper: classes.paper}}
          >
            <div style={divStyle}>
              <List component="nav" aria-label="main mailbox folders">
                {this.state.pops_search_res.map(e => (
                  <React.Fragment key={"fragmentId_"+e.loc_id}>
                    <ListItem>
                      {/* <div style={{display:"flex", alignItems:"left", "minWidth":"4%"}}>
                        <span style={{"textAlign":"left", display:"block", fontSize:"0.8rem", fontFamily:'"Helvetica"', fontWeight:"300", color:"#1a1a1a"}}>{this.get_index_FromObj(e)}</span>
                      </div> */}
                      <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={12}><div style={{fontSize:"0.8rem", fontFamily:'"Helvetica"', fontWeight:"300", color:"#35B6B4"}}>{this.get_name_FromObj(e)}</div></GridItem>
                        <GridItem xs={12} sm={12} md={12}><div style={{fontSize:"0.8rem", fontFamily:'"Helvetica"', fontWeight:"300", color:"#1a1a1a"}}>{this.get_address_FromObj(e)} {this.get_localename_FromObj(e)} {this.get_postcode_FromObj(e)}</div></GridItem>
                        <GridItem xs={12} sm={12} md={12}><div style={{fontSize:"0.8rem", fontFamily:'"Helvetica"', fontWeight:"300", color:"#1a1a1a"}}><b>{this.NSInforString("StoreLocator2_lbl_timetable")}: </b>{this.get_timetable_FromObj(e)} - <b><span style={{color:this.get_isOpenNow_FromObj_Color(e)}}>{this.get_isOpenNow_FromObj(e)===true? this.NSInforString("StoreLocator_lbl_open"):this.NSInforString("StoreLocator_lbl_closed")}</span></b></div></GridItem>
                        <GridItem xs={12} sm={12} md={12}><div style={{fontSize:"0.8rem", fontFamily:'"Helvetica"', fontWeight:"300", color:"#1a1a1a"}}><b>{this.NSInforString("StoreLocator2_lbl_phoneNumber")}: </b><a href={"tel://"+this.get_phone_FromObj(e)}>{this.get_phone_FromObj(e)}</a></div></GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <div style={{fontSize:"0.8rem", fontFamily:'"Helvetica"', fontWeight:"300", color:"#1a1a1a"}}><b>{this.NSInforString("StoreLocator2_lbl_label5")} </b><br/>
                          {this.show_WU_image(e)===false ? ("") : <div style={{display:"inline-block", "verticalAlign":"top"}}><img src={logo_wu_SVG} width="124" height="37" alt="" /><span style={{"textAlign":"center", fontSize:"0.65rem",display:"block"}}>Western Union</span></div> }
                          &nbsp;
                          {this.show_GC_image(e)===false ? ("") : <div style={{display:"inline-block", "verticalAlign":"top"}}><img src={logo_gc_SVG} width="161" height="37" alt="" /><span style={{"textAlign":"center", fontSize:"0.65rem",display:"block"}}>{this.NSInforString("StoreLocator_bill_payment_text")}</span></div> }
                          </div>
                        </GridItem>
                      </GridContainer>
                      <Button onClick={(event,value) => this.Directions_list_act(event,e)}>
                        <div className={classes.WU_FORM_promo_openclose}><DirectionsIcon fontSize="large"/>
                        {localStorage.getItem("mobileOpen")==="true" ? "":this.NSInforString("StoreLocator2_lbl_directions")}
                        <span style={{"textAlign":"center", fontSize:"0.75rem",display:"block"}}>{this.getDistanceFromLatLonInKm_HTML(localStorage.getItem("gpslat"),localStorage.getItem("gpslon"),this.get_gm_latitude_FromObj(e),this.get_gm_longitude_FromObj(e))}</span>
                        </div>
                      </Button>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                ))}
              </List>
              <DialogActions>
                {localStorage.getItem("mobileOpen")==="true" ? (
                  <IconButton className={classes.customizedButton_mobile} onClick={this.dialog3_handleClose}><CloseIcon /></IconButton>
                ) : (
                  <IconButton className={classes.customizedButton} onClick={this.dialog3_handleClose}><CloseIcon /></IconButton>
                )}
              </DialogActions>
            </div>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP][FAB]--- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog100_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog100_handleClose}
            aria-labelledby="alert-dialog100-slide-title"
            aria-describedby="alert-dialog100-slide-description"
          >
            <DialogTitle id="alert-dialog100-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="en" ? (
              <DialogContent>Need assistance?<br/>We are at your disposal!<br/>Call us at<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>or<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(toll free from a landline)<br/><br/>Call Center operating hours:<br/>Monday to Sunday 08:00 με 21:00</DialogContent>
            ) : (
              <DialogContent>Χρειάζεσαι βοήθεια;<br/>Είμαστε στη διάθεσή σου!<br/>Κάλεσε μας στο<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>ή στο<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(χωρίς χρέωση από σταθερό)<br/><br/>Ωράριο τηλεφωνικής εξυπηρέτησης:<br/>Δευτέρα με Κυριακή 08:00 με 21:00</DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog100_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------------ */}
        {/* ----------[POPUP][CAMPAIGN]--- */}
        {/* ------------------------------ */}
        <div>
          <Dialog
            open={this.state.dialog101_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog101_handleClose}
            aria-labelledby="alert-dialog101-slide-title"
            aria-describedby="alert-dialog101-slide-description"
          >
            <DialogTitle id="alert-dialog101-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="el" ? (
              <DialogContent><img src={WU_popup_campaign_el} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            ) : (
              <DialogContent><img src={WU_popup_campaign_en} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog101_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* --------------------------------------- */}
        {/* ----------[POPUP checkAppVersion]------ */}
        {/* --------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_checkAppVersion_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_checkAppVersion_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_checkAppVersion_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_checkAppVersion} color="default" onClick={this.dialog_checkAppVersion_btn_ok}>{this.NSInforString("dialog_checkAppVersion_btn_ok")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_mapOrList(event) {
    let methName = filename+"handleCheckBoxClick_mapOrList ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({ "showResultsOnMap":event.target.checked });
  }
  handleCheckBoxClick_BillsorNot(event) {
    let methName = filename+"handleCheckBoxClick_BillsorNot ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({ "showBPStores":event.target.checked });
  }
  handleCheckBoxClick_WUorNot(event) {
    let methName = filename+"handleCheckBoxClick_WUorNot ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({ "showWUStores":event.target.checked });
  }
  handleCheckBoxClick_Timetable(event) {
    let methName = filename+"handleCheckBoxClick_Timetable ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    if(event.target.checked){
      this.setState({
        "timetableValue"       : "openNow",
        "searchUsingTimetable" : event.target.checked,
      });
    }
    else{
      this.setState({
        "timetableValue"       : "",
        "searchUsingTimetable" : event.target.checked,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------
  //Consent-offers
  handleRadioButtonClick_timetable(event) {
    let methName = filename+"handleRadioButtonClick_timetable ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}

    if(eventTMP==="openNow"){
      this.setState({
        "timetableValue"       : eventTMP,
        "searchUsingTimetable" : true,
      });
    }
    else if(eventTMP==="openTodayAfternoon"){
      this.setState({
        "timetableValue"       : eventTMP,
        "searchUsingTimetable" : true,
      });
    }
    else if(eventTMP==="sunday")   { this.setState({"timetableValue":eventTMP,"searchUsingTimetable":true }); }
    else if(eventTMP==="monday")   { this.setState({"timetableValue":eventTMP,"searchUsingTimetable":true }); }
    else if(eventTMP==="tuesday")  { this.setState({"timetableValue":eventTMP,"searchUsingTimetable":true }); }
    else if(eventTMP==="wednesday"){ this.setState({"timetableValue":eventTMP,"searchUsingTimetable":true }); }
    else if(eventTMP==="thursday") { this.setState({"timetableValue":eventTMP,"searchUsingTimetable":true }); }
    else if(eventTMP==="friday")   { this.setState({"timetableValue":eventTMP,"searchUsingTimetable":true }); }
    else if(eventTMP==="saturday") { this.setState({"timetableValue":eventTMP,"searchUsingTimetable":true }); }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  Directions_list_act(event,obj) {
    let methName = filename+"Directions_list_act ";
    if(api.print_logs){console.log(methName+obj.gm_latitude+","+obj.gm_longitude);}

    try{
      //console.log(methName+obj.gm_latitude);
      //console.log(methName+obj.gm_longitude);
      window.open('https://www.google.com/maps/dir/?api=1&destination='+obj.gm_latitude+','+obj.gm_longitude+'','_blank');
    //window.open('http://maps.google.com/maps?q=loc:'+obj.gm_latitude+','+obj.gm_longitude+'&navigate=yes','_blank');//till 13/01/2025
    //window.open('http://maps.google.com/maps?daddr='+obj.gm_latitude+','+obj.gm_longitude+'&mrsp=0','_blank');
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  StoreLocator_btn_WU(event){
    let methName = filename+"StoreLocator_btn_WU ";
    if(api.print_logs){console.log(methName);}

    let StoreLocator_btn_WU_isActive_PREV = this.state.StoreLocator_btn_WU_isActive;
    let StoreLocator_btn_BP_isActive_CURR = this.state.StoreLocator_btn_BP_isActive;
    if(StoreLocator_btn_WU_isActive_PREV===true && StoreLocator_btn_BP_isActive_CURR===false){
      this.Snackbar_textField_handleOpen(this.NSInforString("StoreLocator_options_msg01"));
    }

    this.setState({
      "StoreLocator_btn_WU_isActive" : !this.state.StoreLocator_btn_WU_isActive,
      "showWUStores"                 : !this.state.showWUStores,
    });
  }
  //----------------------------------------------------------------------------------------------------
  StoreLocator_btn_BP(event){
    let methName = filename+"StoreLocator_btn_BP ";
    if(api.print_logs){console.log(methName);}

    let StoreLocator_btn_WU_isActive_CURR = this.state.StoreLocator_btn_WU_isActive;
    let StoreLocator_btn_BP_isActive_PREV = this.state.StoreLocator_btn_BP_isActive;
    if(StoreLocator_btn_WU_isActive_CURR===false && StoreLocator_btn_BP_isActive_PREV===true){
      this.Snackbar_textField_handleOpen(this.NSInforString("StoreLocator_options_msg01"));
    }

    this.setState({
      "StoreLocator_btn_BP_isActive" : !this.state.StoreLocator_btn_BP_isActive,
      "showBPStores"                 : !this.state.showBPStores,
    });
  }
  //----------------------------------------------------------------------------------------------------
  StoreLocator_btn_map(event){
    let methName = filename+"StoreLocator_btn_map ";
    if(api.print_logs){console.log(methName);}

    if(this.state.loadGoogleMapFix===false){
      this.setState({
        "loadGoogleMapFix" : true,
        "StoreLocator_btn_map_isActive" : !this.state.StoreLocator_btn_map_isActive,
        "showResultsOnMap"              : !this.state.showResultsOnMap,
      });
    }
    else{
      this.setState({
        "StoreLocator_btn_map_isActive" : !this.state.StoreLocator_btn_map_isActive,
        "showResultsOnMap"              : !this.state.showResultsOnMap,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  StoreLocator_btn_openTodayAfternoon(event){
    let methName = filename+"StoreLocator_btn_openTodayAfternoon ";
    if(api.print_logs){console.log(methName);}

    if(this.state.StoreLocator_btn_openTodayAfternoon_isActive){
      this.setState({
        "timetableValue"                               : "openTodayAfternoon",
        "searchUsingTimetable"                         : false,
        "StoreLocator_btn_openTodayAfternoon_isActive" : false,
      });
    }
    else{
      this.setState({
        "timetableValue"                               : "openTodayAfternoon",
        "searchUsingTimetable"                         : true,
        "StoreLocator_btn_openTodayAfternoon_isActive" : true,
        "StoreLocator_btn_openNow_isActive"            : false,
        "StoreLocator_btn_sunday_isActive"             : false,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  StoreLocator_btn_openNow(event){
    let methName = filename+"StoreLocator_btn_openNow ";
    if(api.print_logs){console.log(methName);}

    if(this.state.StoreLocator_btn_openNow_isActive){
      this.setState({
        "timetableValue"                               : "openNow",
        "searchUsingTimetable"                         : false,
        "StoreLocator_btn_openNow_isActive"            : false,
      });
    }
    else{
      this.setState({
        "timetableValue"                               : "openNow",
        "searchUsingTimetable"                         : true,
        "StoreLocator_btn_openTodayAfternoon_isActive" : false,
        "StoreLocator_btn_openNow_isActive"            : true,
        "StoreLocator_btn_sunday_isActive"             : false,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  StoreLocator_btn_sunday(event){
    let methName = filename+"StoreLocator_btn_sunday ";
    if(api.print_logs){console.log(methName);}

    if(this.state.StoreLocator_btn_sunday_isActive){
      this.setState({
        "timetableValue"                               : "sunday",
        "searchUsingTimetable"                         : false,
        "StoreLocator_btn_sunday_isActive"             : false,
      });
    }
    else{
      this.setState({
        "timetableValue"                               : "sunday",
        "searchUsingTimetable"                         : true,
        "StoreLocator_btn_openTodayAfternoon_isActive" : false,
        "StoreLocator_btn_openNow_isActive"            : false,
        "StoreLocator_btn_sunday_isActive"             : true,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  StoreLocator_btn_search_isDisabled(){
    //if(this.verifyLength(this.state.textField1,1)===false){ return true; } //mtcn
    return false;
  }
  StoreLocator_btn_search_with_enter(event){
    if (event.charCode === 13) { // enter key pressed
      event.preventDefault();
      this.setState({
      //"textField1"          : "",
        "textField1_hasError" : false,
        "searchNearest"       : false,
        "searchAddress"       : false,
        "dialogS_isOpen"      : false,
      });
      setTimeout(function() {
        this.StoreLocator_btn_search(event);
      }.bind(this), 100);
    }
    //let this_state_textField1 = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value : this.state.textField1;
    //console.log("StoreLocator_btn_search_with_enter this_state_textField1="+this_state_textField1);
  }
  //----------------------------------------------------------------------------------------------------
  StoreLocator_btn_nearest_isDisabled(){
    //if(this.verifyLength(this.state.textField1,1)===false){ return true; } //mtcn
    return false;
  }
  StoreLocator_btn_nearest(event) {
    let methName = filename+"StoreLocator_btn_nearest ";
    if(api.print_logs){console.log(methName);}

    event.preventDefault();
    this.setState({
      "textField1"             : "",
      "textField1_inputValue"  : "",
      "textField1b_inputValue" : "",
      "textField1_hasError"    : false,
      "textField1b_hasError"   : false,
      "searchNearest"          : true,
      "searchAddress"          : false,
      "dialogS_isOpen"         : false,
    });
    setTimeout(function() {
      //document.getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click();
      this.StoreLocator_btn_search(event);
    }.bind(this), 100);
  }
  //----------------------------------------------------------------------------------------------------
  StoreLocator_btn_search(event) {
    let methName = filename+"StoreLocator_btn_search ";
    if(api.print_logs){console.log(methName);}

    let pops_search_res = [];
    let this_state_textField1  = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value  : this.state.textField1;
    let this_state_textField1b = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1b_autocomplete").value : "";
    let searchTerm             = (this.state.searchAddress===true) ? this_state_textField1b.trim() : this_state_textField1.trim();
    let search_S = new Date();
    let search_E = new Date();
    console.log(methName+"this_state_textField1  = "+this_state_textField1);
    console.log(methName+"this_state_textField1b = "+this_state_textField1b);
    console.log(methName+"searchTerm             = "+searchTerm);

    if(this.state.searchAddress===true || this.state.searchNearest){
      let lat1 = "";
      let lon1 = "";
      if(this.state.searchAddress===true){
        lat1 = localStorage.getItem("gpslat_address");
        lon1 = localStorage.getItem("gpslon_address");
        if(lat1===null || (typeof lat1 === "undefined") || lat1==="" || lon1===null || (typeof lon1 === "undefined") || lon1===""){
          this.dialog_handleOpen(this.NSInforString("StoreLocator2_showNearest_errMsg"));
          return;
        }
      }
      if(this.state.searchNearest===true){
        lat1 = localStorage.getItem("gpslat");
        lon1 = localStorage.getItem("gpslon");
        if(lat1===null || (typeof lat1 === "undefined") || lat1==="" || lon1===null || (typeof lon1 === "undefined") || lon1===""){
          this.dialog_handleOpen(this.NSInforString("StoreLocator2_showNearest_errMsg"));
          return;
        }
      }

      search_S = new Date();
      // if(pops_search_res.length===0){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations, 3,lat1,lon1); }
      // if(pops_search_res.length===0){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations, 6,lat1,lon1); }
      // if(pops_search_res.length===0){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations, 9,lat1,lon1); }
      // if(pops_search_res.length===0){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,15,lat1,lon1); }
      // if(pops_search_res.length===0){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,30,lat1,lon1); }
      // if(pops_search_res.length===0){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,45,lat1,lon1); }
      // if(pops_search_res.length===0){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,60,lat1,lon1); }
      // if(pops_search_res.length===0){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,90,lat1,lon1); }
      if(pops_search_res.length<3){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations, 3,lat1,lon1); }
      if(pops_search_res.length<3){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations, 6,lat1,lon1); }
      if(pops_search_res.length<3){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations, 9,lat1,lon1); }
      if(pops_search_res.length<3){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,15,lat1,lon1); }
      if(pops_search_res.length<3){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,30,lat1,lon1); }
      if(pops_search_res.length<3){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,45,lat1,lon1); }
      if(pops_search_res.length<3){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,60,lat1,lon1); }
      if(pops_search_res.length<3){ pops_search_res = this.makeHTTPConn_nearest(this.state.parserObject_getLocations,90,lat1,lon1); }
      search_E = new Date();
    }
    else{
      //++++++++++++++++++++++
      //webapp session timeout
      //++++++++++++++++++++++
      if(wu_Utilities.checkIfUserIsLoggedIn()){
        wu_Utilities.update_uilatstats();
        if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
      }
      //+++++++++++++++++++++++
      //validate Only Emptyness
      //+++++++++++++++++++++++
      let validateOnlyEmptyness = true;
      if(validateOnlyEmptyness){
        let emptyFields = false;
        if(!(this_state_textField1b.trim() !== "" || this_state_textField1.trim() !== "")){
          if(this_state_textField1b.trim() === ""){ this.setState({"textField1b_hasError" : true }); emptyFields = true; }
          if(this_state_textField1b.trim() === ""){ this.setState({"textField1_hasError"  : true }); emptyFields = true; }
          if(emptyFields===true){return;}
        }
      }
      if(this_state_textField1b.trim() !== "" && (localStorage.getItem("gpslat_address")==="" || localStorage.getItem("gpslon_address")==="") ){
        this.setState({"textField1b_hasError" : true });
        this.Snackbar_textField_handleOpen(this.NSInforString("StoreLocator_search_msg04"));
        return;
      }

      //let storeloc_flow = api.storeloc_flow_NORMAL_FLOW;
      if(!this.state.parserObject_getLocations){
          this.dialog_handleOpen(this.NSInforString("StoreLocator_search_msg02"));
          return;
      }
      if(this_state_textField1 === ""){
          this.dialog_handleOpen(this.NSInforString("StoreLocator_search_msg01"));
          return;
      }

      let TextField1Text_NoTone   = this.replaceTonoumena(this_state_textField1.trim().toUpperCase());
      TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
      TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
      TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
      TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
      TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
      let TextField1Text_NoTone_arr = TextField1Text_NoTone.split(" ");

      search_S = new Date();
      pops_search_res = this.search_auxiliary(this.state.parserObject_getLocations,TextField1Text_NoTone_arr[0]);
      for (let j=0; j<TextField1Text_NoTone_arr.length; ++j) {
          pops_search_res = this.search_auxiliary(pops_search_res,TextField1Text_NoTone_arr[j]);
      }
      search_E = new Date();
    }
    for(let i=0; i<pops_search_res.length; ++i){
      pops_search_res[i]["index"] = i+1;
    }



    if(api.print_logs){console.log("parserObject_getLocations.length = "+this.state.parserObject_getLocations.length);}
    if(api.print_logs){console.log("pops_search_res.length           = "+pops_search_res.length);}
    if(api.print_logs){console.log("Search START                     = "+search_S);}
    if(api.print_logs){console.log("Search END                       = "+search_E);}
    if(pops_search_res.length===0){
        this.dialogS_handleOpen(this.NSInforString("StoreLocator_search_msg02"));
    }
    else{
        let avGeo = this.averageGeolocation(pops_search_res); if(api.print_logs){console.log('avGeo='+JSON.stringify(avGeo));}
        let zoomL = this.getCenterPosition(pops_search_res);  if(api.print_logs){console.log('zoomL='+zoomL);}
        this.setState({
          "initialCenter_lat" : avGeo.gm_latitude,
          "initialCenter_lon" : avGeo.gm_longitude,
          "initialZoom"       : parseInt(zoomL),
          "pops_search_res"   : pops_search_res,
          "searchNearest"     : false,
        //"searchAddress"     : false,
        });
        if(this.state.showResultsOnMap){ setTimeout(function() {this.dialog2_handleOpen(this.NSInforString("StoreLocator_search_msg01"));}.bind(this), 200); }
        else                           { setTimeout(function() {this.dialog3_handleOpen(this.NSInforString("StoreLocator_search_msg01"));}.bind(this), 200); }
    }

    let tagManagerData = {
      'event'      : 'search',
      'searchTerm' : searchTerm
    };
    //TagManager.dataLayer(tagManagerData);
    try { window.dataLayer.push(tagManagerData);                }catch(err1){console.log(methName+"err1="+err1);}
    try { console.log(methName+JSON.stringify(tagManagerData)); }catch(err2){console.log(methName+"err2="+err2);}
  }
  //----------------------------------------------------------------------------------------------------
  search_auxiliary(local_parserObject_getLocations,TextField1Text){

    let pops_search_res = [];

    let loc_id = 0;
    //----------
    let loc_name               = "";
    let prefecture_name_el     = "";
    let prefecture_name_en     = "";
    let sub_prefecture_name_el = "";
    let sub_prefecture_name_en = "";
    let municipal_name_el      = "";
    let municipal_name_en      = "";
    let locale_name_el         = "";
    let locale_name_en         = "";
    let tel                    = "";
    let post_code              = "";
    let addr_el                = "";
    let addr_en                = "";
    let city_el                = ""; //new
    let city_en                = "";
    let zone_name_el           = "";
    let zone_name_en           = "";
    let subzone_name_el        = "";
    let subzone_name_en        = "";
    //----------
    let loc_name_Index               = -1;
    let prefecture_name_el_Index     = -1;
    let prefecture_name_en_Index     = -1;
    let sub_prefecture_name_el_Index = -1;
    let sub_prefecture_name_en_Index = -1;
    let municipal_name_el_Index      = -1;
    let municipal_name_en_Index      = -1;
    let locale_name_el_Index         = -1;
    let locale_name_en_Index         = -1;
    let tel_Index                    = -1;
    let post_code_Index              = -1;
    let addr_el_Index                = -1;
    let addr_en_Index                = -1;
    let city_el_Index                = -1; //new
    let city_en_Index                = -1;
    let zone_name_el_Index           = -1;
    let zone_name_en_Index           = -1;
    let subzone_name_el_Index        = -1;
    let subzone_name_en_Index        = -1;
    //----------
    let       isNotSearchResult = true;
    let       MAXRESULTS        = 750;
    let       foundResults      = 0;
    let TextField1Text_NoTone   = this.replaceTonoumena(TextField1Text.trim().toUpperCase());

    let aRow = null;
    let cnt = local_parserObject_getLocations.length;
    if(api.print_logs){console.log("cnt="+cnt);}
    if(api.print_logs){console.log("Search START="+new Date());}
    for (let i=0; i<cnt; ++i) {
        aRow = local_parserObject_getLocations[i];
        isNotSearchResult            = true;
        loc_name_Index               = -1;
        prefecture_name_el_Index     = -1;
        prefecture_name_en_Index     = -1;
        sub_prefecture_name_el_Index = -1;
        sub_prefecture_name_en_Index = -1;
        municipal_name_el_Index      = -1;
        municipal_name_en_Index      = -1;
        locale_name_el_Index         = -1;
        locale_name_en_Index         = -1;
        tel_Index                    = -1;
        post_code_Index              = -1;
        addr_el_Index                = -1;
        addr_en_Index                = -1;
        city_el_Index                = -1; //new
        city_en_Index                = -1;
        zone_name_el_Index           = -1;
        zone_name_en_Index           = -1;
        subzone_name_el_Index        = -1;
        subzone_name_en_Index        = -1;

        if(foundResults===MAXRESULTS){
            break;
        }
        try { loc_id = aRow["loc_id"]; }catch(err){ loc_id = 0; }

        try { loc_name               = aRow["loc_name"];               }catch(err){ loc_name               = ""; } if(loc_name               === null){loc_name               = "";}
        try { prefecture_name_el     = aRow["prefecture_name_el"];     }catch(err){ prefecture_name_el     = ""; } if(prefecture_name_el     === null){prefecture_name_el     = "";}
        try { prefecture_name_en     = aRow["prefecture_name_en"];     }catch(err){ prefecture_name_en     = ""; } if(prefecture_name_en     === null){prefecture_name_en     = "";}
        try { sub_prefecture_name_el = aRow["sub_prefecture_name_el"]; }catch(err){ sub_prefecture_name_el = ""; } if(sub_prefecture_name_el === null){sub_prefecture_name_el = "";}
        try { sub_prefecture_name_en = aRow["sub_prefecture_name_en"]; }catch(err){ sub_prefecture_name_en = ""; } if(sub_prefecture_name_en === null){sub_prefecture_name_en = "";}
        try { municipal_name_el      = aRow["municipal_name_el"];      }catch(err){ municipal_name_el      = ""; } if(municipal_name_el      === null){municipal_name_el      = "";}
        try { municipal_name_en      = aRow["municipal_name_en"];      }catch(err){ municipal_name_en      = ""; } if(municipal_name_en      === null){municipal_name_en      = "";}
        try { locale_name_el         = aRow["locale_name_el"];         }catch(err){ locale_name_el         = ""; } if(locale_name_el         === null){locale_name_el         = "";}
        try { locale_name_en         = aRow["locale_name_en"];         }catch(err){ locale_name_en         = ""; } if(locale_name_en         === null){locale_name_en         = "";}
        try { tel                    = aRow["tel"];                    }catch(err){ tel                    = ""; } if(tel                    === null){tel                    = "";}
        try { post_code              = aRow["post_code"];              }catch(err){ post_code              = ""; } if(post_code              === null){post_code              = "";}
        try { addr_el                = aRow["addr_el"];                }catch(err){ addr_el                = ""; } if(addr_el                === null){addr_el                = "";}
        try { addr_en                = aRow["addr_en"];                }catch(err){ addr_en                = ""; } if(addr_en                === null){addr_en                = "";}
        try { city_el                = aRow["city_el"];                }catch(err){ city_el                = ""; } if(city_el                === null){city_el                = "";}//new
        try { city_en                = aRow["city_en"];                }catch(err){ city_en                = ""; } if(city_en                === null){city_en                = "";}
        try { zone_name_el           = aRow["zone_name_el"];           }catch(err){ zone_name_el           = ""; } if(zone_name_el           === null){zone_name_el           = "";}
        try { zone_name_en           = aRow["zone_name_en"];           }catch(err){ zone_name_en           = ""; } if(zone_name_en           === null){zone_name_en           = "";}
        try { subzone_name_el        = aRow["subzone_name_el"];        }catch(err){ subzone_name_el        = ""; } if(subzone_name_el        === null){subzone_name_el        = "";}
        try { subzone_name_en        = aRow["subzone_name_en"];        }catch(err){ subzone_name_en        = ""; } if(subzone_name_en        === null){subzone_name_en        = "";}

        loc_name_Index               = this.replaceTonoumena(loc_name.toUpperCase()).indexOf(TextField1Text_NoTone);
        prefecture_name_el_Index     = this.replaceTonoumena(prefecture_name_el.toUpperCase()).indexOf(TextField1Text_NoTone);
        prefecture_name_en_Index     =                       prefecture_name_en.toUpperCase().indexOf(TextField1Text_NoTone);
        sub_prefecture_name_el_Index = this.replaceTonoumena(sub_prefecture_name_el.toUpperCase()).indexOf(TextField1Text_NoTone);
        sub_prefecture_name_en_Index =                       sub_prefecture_name_en.toUpperCase().indexOf(TextField1Text_NoTone);
        municipal_name_el_Index      = this.replaceTonoumena(municipal_name_el.toUpperCase()).indexOf(TextField1Text_NoTone);
        municipal_name_en_Index      =                       municipal_name_en.toUpperCase().indexOf(TextField1Text_NoTone);
        locale_name_el_Index         = this.replaceTonoumena(locale_name_el.toUpperCase()).indexOf(TextField1Text_NoTone);
        locale_name_en_Index         =                       locale_name_en.toUpperCase().indexOf(TextField1Text_NoTone);
        tel_Index                    = tel.toUpperCase().indexOf(TextField1Text_NoTone);
        post_code_Index              = post_code.toUpperCase().indexOf(TextField1Text_NoTone);
        addr_el_Index                = this.replaceTonoumena(addr_el.toUpperCase()).indexOf(TextField1Text_NoTone);
        addr_en_Index                =                       addr_en.toUpperCase().indexOf(TextField1Text_NoTone);
        city_el_Index                = this.replaceTonoumena(city_el.toUpperCase()).indexOf(TextField1Text_NoTone);         //new
        city_en_Index                =                       city_en.toUpperCase().indexOf(TextField1Text_NoTone);
        zone_name_el_Index           = this.replaceTonoumena(zone_name_el.toUpperCase()).indexOf(TextField1Text_NoTone);
        zone_name_en_Index           =                       zone_name_en.toUpperCase().indexOf(TextField1Text_NoTone);
        subzone_name_el_Index        = this.replaceTonoumena(subzone_name_el.toUpperCase()).indexOf(TextField1Text_NoTone);
        subzone_name_en_Index        =                       subzone_name_en.toUpperCase().indexOf(TextField1Text_NoTone);

        if (loc_name_Index               !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")loc_name              ="+loc_name);} }
        if (prefecture_name_el_Index     !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")prefecture_name_el    ="+prefecture_name_el);} }
        if (prefecture_name_en_Index     !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")prefecture_name_en    ="+prefecture_name_en);} }
        if (sub_prefecture_name_el_Index !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")sub_prefecture_name_el="+sub_prefecture_name_el);} }
        if (sub_prefecture_name_en_Index !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")sub_prefecture_name_en="+sub_prefecture_name_en);} }
        if (municipal_name_el_Index      !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")municipal_name_el     ="+municipal_name_el);} }
        if (municipal_name_en_Index      !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")municipal_name_en     ="+municipal_name_en);} }
        if (locale_name_el_Index         !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")locale_name_el        ="+locale_name_el);} }
        if (locale_name_en_Index         !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")locale_name_en        ="+locale_name_en);} }
        if (tel_Index                    !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")tel                   ="+tel);} }
        if (post_code_Index              !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")post_code             ="+post_code);} }
        if (addr_el_Index                !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")addr_el               ="+addr_el);} }
        if (addr_en_Index                !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")addr_en               ="+addr_en);} }
        if (city_el_Index                !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")city_el               ="+city_el);} }         //new
        if (city_en_Index                !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")city_en               ="+addr_en);} }
        if (zone_name_el_Index           !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")zone_name_el          ="+zone_name_el);} }
        if (zone_name_en_Index           !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")zone_name_en          ="+zone_name_en);} }
        if (subzone_name_el_Index        !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")subzone_name_el       ="+subzone_name_el);} }
        if (subzone_name_en_Index        !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")subzone_name_en       ="+subzone_name_en);} }

        if(isNaN(parseFloat(aRow["gm_latitude"])) || isNaN(parseFloat(aRow["gm_longitude"]))){
          isNotSearchResult=true;
        }

        let already_exists = this.itemAlreadyExistsInArray(pops_search_res,loc_id);
        if(already_exists===true){
            isNotSearchResult = true;
        }

        //-----------------------------------------------------
        //Filter Western Union
        //Filter Bill Stores
        //If already the result is excluded do not run the code
        //-----------------------------------------------------
        if(this.state.autoCompleteSearchEnabled===true){
          if(isNotSearchResult===false){
            let has_WU = this.canTransferWU(aRow);
            let has_BP = this.canPayBill(aRow);
            if(this.state.showWUStores===true  && this.state.showBPStores===true){
              if(has_WU===true  && has_BP===true ){ }
              if(has_WU===true  && has_BP===false){ isNotSearchResult = true; }
              if(has_WU===false && has_BP===true ){ isNotSearchResult = true; }
              if(has_WU===false && has_BP===false){ isNotSearchResult = true; }
            }
            if(this.state.showWUStores===true  && this.state.showBPStores===false){
              if(has_WU===true ){ }
              if(has_WU===false){ isNotSearchResult = true; }
            }
            if(this.state.showWUStores===false && this.state.showBPStores===true){
              if(has_BP===true ){ }
              if(has_BP===false){ isNotSearchResult = true; }
            }
            if(this.state.showWUStores===false && this.state.showBPStores===false){
              isNotSearchResult = true;
            }
          }
        }
        //-----------------------------------------------------
        //Filter Timetable
        //If already the result is excluded do not run the code
        //-----------------------------------------------------
        if(this.state.autoCompleteSearchEnabled===true){
          if(isNotSearchResult===false){
            if(this.state.searchUsingTimetable){
              if(wu_Utilities.timetableFiltering(aRow,this.state.timetableValue)===false){
                isNotSearchResult = true;
              }
            }
          }
        }

        if(isNotSearchResult===false){
            aRow = null;
            try { aRow = local_parserObject_getLocations[i]; } catch(err){;}
            //let gm_latitude      = 0.0; try { if(aRow["gm_latitude"] !==null){gm_latitude  = aRow["gm_latitude"];}  }catch(err){;}
            //let gm_longitude     = 0.0; try { if(aRow["gm_longitude"]!==null){gm_longitude = aRow["gm_longitude"];} }catch(err){;}

            let loc_Services = ""; try { loc_Services = aRow["loc_Services"]; }catch(err){;} if(loc_Services === null){loc_Services = "";}
            //NSLog(@"%@ %@",[NSString stringWithFormat:@"%.6f",gm_latitude],[NSString stringWithFormat:@"%.6f",gm_longitude]);
            aRow["InfoWindowVisible"] = false;
            aRow["distance"]          = this.getDistanceFromLatLonInKm(localStorage.getItem("gpslat"),localStorage.getItem("gpslon"),this.get_gm_latitude_FromObj(aRow),this.get_gm_longitude_FromObj(aRow)); //console.log("distance="+aRow["distance"] );
            pops_search_res.push(aRow);
            foundResults = foundResults +1;
        }
    }
    pops_search_res.sort((a,b) => (a.distance > b.distance) ? 1 : ((b.distance > a.distance) ? -1 : 0));

    if(api.print_logs){console.log("Search END             = ",new Date());}
    if(api.print_logs){console.log("pops_search_res.length = "+pops_search_res.length);}
    return pops_search_res;
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_nearest(local_parserObject_getLocations,flow_MAX_DISTANCE,lat1,lon1){
      if(api.print_logs){console.log("--------------------------------------------------");}
      if(api.print_logs){console.log("makeHTTPConn_nearest lat1="+lat1);}
      if(api.print_logs){console.log("makeHTTPConn_nearest lon1="+lon1);}
      if(lat1===null || (typeof lat1 === "undefined") || lat1==="" || lon1===null || (typeof lon1 === "undefined") || lon1===""){
          return [];
      }

      //let flow_MAX_DISTANCE = 3; // 3km
      let pops_nearest_all = [];
      let allitemsCnt  = local_parserObject_getLocations.length;
      let gm_latitude  = 0.0;
      let gm_longitude = 0.0;
      let loc_Services = "";
      let isNotSearchResult = false;
      for(let i=0; i<allitemsCnt; ++i){
          isNotSearchResult = false;
          let aRow = null;
          try { aRow = local_parserObject_getLocations[i]; } catch(err){;}
          gm_latitude  = 0.0;
          gm_longitude = 0.0;
          loc_Services = "";
          try { if( aRow["gm_latitude"]  !== null ){gm_latitude  = parseFloat(aRow["gm_latitude"]);} }catch(err){;}
          try { if( aRow["gm_longitude"] !== null ){gm_longitude = parseFloat(aRow["gm_longitude"]);} }catch(err){;}
          try { loc_Services = aRow["loc_Services"]; }catch(err){;}if(loc_Services===null){loc_Services = "";}
          //console.log("loc_Services="+loc_Services+" "+gm_latitude.toFixed(6)+","+gm_longitude.toFixed(6));

          let gm_distance = -1;
          if(gm_latitude!==0.0 && gm_longitude!==0.0){
              gm_distance = this.getDistanceFromLatLonInKm(lat1,lon1,gm_latitude.toFixed(6),gm_longitude.toFixed(6));
          }

          //-----------------------------------------------------
          //Filter Western Union
          //Filter Bill Stores
          //If already the result is excluded do not run the code
          //-----------------------------------------------------
          if(this.state.autoCompleteSearchEnabled===true){
            if(isNotSearchResult===false){
              let has_WU = this.canTransferWU(aRow);
              let has_BP = this.canPayBill(aRow);
              if(this.state.showWUStores===true  && this.state.showBPStores===true){
                if(has_WU===true  && has_BP===true ){ }
                if(has_WU===true  && has_BP===false){ isNotSearchResult = true; }
                if(has_WU===false && has_BP===true ){ isNotSearchResult = true; }
                if(has_WU===false && has_BP===false){ isNotSearchResult = true; }
              }
              if(this.state.showWUStores===true  && this.state.showBPStores===false){
                if(has_WU===true ){ }
                if(has_WU===false){ isNotSearchResult = true; }
              }
              if(this.state.showWUStores===false && this.state.showBPStores===true){
                if(has_BP===true ){ }
                if(has_BP===false){ isNotSearchResult = true; }
              }
              if(this.state.showWUStores===false && this.state.showBPStores===false){
                isNotSearchResult = true;
              }
            }
          }
          //-----------------------------------------------------
          //Filter Timetable
          //If already the result is excluded do not run the code
          //-----------------------------------------------------
          if(this.state.autoCompleteSearchEnabled===true){
            if(isNotSearchResult===false){
              if(this.state.searchUsingTimetable){
                if(wu_Utilities.timetableFiltering(aRow,this.state.timetableValue)===false){
                  isNotSearchResult = true;
                }
              }
            }
          }
          if(isNotSearchResult===false){
            if(gm_distance>=0 && gm_distance<flow_MAX_DISTANCE){
                //console.log("loc_Services="+loc_Services+" gm_distance="+gm_distance+" "+gm_latitude.toFixed(6)+","+gm_longitude.toFixed(6));
                let addStoreToList = false;
                let storeType = "";
                let WUIndex = loc_Services.indexOf("WU");
                let GCIndex = loc_Services.indexOf("GC");
              //let BPIndex = loc_Services.indexOf("BP");
                if(WUIndex>=0 && GCIndex>=0){storeType = "GC";}
                if(WUIndex <0 && GCIndex>=0){storeType = "GC";}
                if(WUIndex>=0 && GCIndex <0){storeType = "WU";}
                if(WUIndex <0 && GCIndex <0){storeType = "WU";}
                     if(storeType ==="GC"){ addStoreToList = true; }
                else if(storeType ==="WU"){ addStoreToList = true; }
                if(addStoreToList){
                    aRow["distance"] = this.getDistanceFromLatLonInKm(lat1,lon1,gm_latitude,gm_longitude);
                    pops_nearest_all.push(aRow);
                }
            }
          }
      }
      pops_nearest_all.sort((a,b) => (a.distance > b.distance) ? 1 : ((b.distance > a.distance) ? -1 : 0));
      return pops_nearest_all;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  itemAlreadyExistsInArray(searchArr,loc_id_search){

      if(loc_id_search===0){
          return false;
      }

      let loc_id = 0;
      let aRow = null;
      let cnt = searchArr.length;
      for(let i=0; i<cnt; ++i){
          aRow = searchArr[i];
          try { loc_id = aRow["loc_id"]; }catch(err){ loc_id = 0; }
          if(loc_id===loc_id_search){
              return true;
          }
      }
      return false;
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  replaceTonoumena(inputStr) {
    inputStr = inputStr.replace(/Ά/g,"Α");
    inputStr = inputStr.replace(/Έ/g,"Ε");
    inputStr = inputStr.replace(/Ή/g,"Η");
    inputStr = inputStr.replace(/Ί/g,"Ι");
    inputStr = inputStr.replace(/Ό/g,"Ο");
    inputStr = inputStr.replace(/Ύ/g,"Υ");
    inputStr = inputStr.replace(/Ώ/g,"Ω");
    return inputStr;
  }
  //----------------------------------------------------------------------------------------------------
  averageGeolocation(coords) {
  if (coords.length === 1) {
    return coords[0];
  }

  let x = 0.0;
  let y = 0.0;
  let z = 0.0;

  for (let coord of coords) {
    let latitude  = coord.gm_latitude  * Math.PI / 180;
    let longitude = coord.gm_longitude * Math.PI / 180;

    x += Math.cos(latitude) * Math.cos(longitude);
    y += Math.cos(latitude) * Math.sin(longitude);
    z += Math.sin(latitude);
  }

  let total = coords.length;

  x = x / total;
  y = y / total;
  z = z / total;

  let centralLongitude = Math.atan2(y, x);
  let centralSquareRoot = Math.sqrt(x * x + y * y);
  let centralLatitude = Math.atan2(z, centralSquareRoot);

  return {
    gm_latitude  : centralLatitude  * 180 / Math.PI,
    gm_longitude : centralLongitude * 180 / Math.PI
  };
}
//----------------------------------------------------------------------------------------------------
//https://stackoverflow.com/questions/15719951/auto-center-map-with-multiple-markers-in-google-maps-api-v3
getCenterPosition(coords){

  //var tempdata = "18.9400|72.8200-19.1717|72.9560-28.6139|77.2090";
  //var tempLat = tempdata.split("-");

  let tempLat = [];
  for (let coord of coords) {
    tempLat.push(coord.gm_latitude.toString() +"|"+coord.gm_longitude.toString());
  }

	var latitudearray  = [];
	var longitudearray = [];
	var i;
	for(i=0; i<tempLat.length;i++){
		var coordinates = tempLat[i].split("|");
		latitudearray.push(coordinates[0]);
		longitudearray.push(coordinates[1]);
	}
	latitudearray.sort(function (a, b) { return a-b; });
	longitudearray.sort(function (a, b) { return a-b; });
	var latdifferenece = latitudearray[latitudearray.length-1] - latitudearray[0];
	//var temp = (latdifferenece / 2).toFixed(4) ;
	//var latitudeMid = parseFloat(latitudearray[0]) + parseFloat(temp);
	var longidifferenece = longitudearray[longitudearray.length-1] - longitudearray[0];
	//temp = (longidifferenece / 2).toFixed(4) ;
	//var longitudeMid = parseFloat(longitudearray[0]) + parseFloat(temp);
	var maxdifference = (latdifferenece > longidifferenece)? latdifferenece : longidifferenece;
	var zoomvalue;
	     if(maxdifference >= 0     && maxdifference <= 0.0037) zoomvalue='17'; //zoom 17
	else if(maxdifference > 0.0037 && maxdifference <= 0.0070) zoomvalue='16'; //zoom 16
	else if(maxdifference > 0.0070 && maxdifference <= 0.0130) zoomvalue='15'; //zoom 15
	else if(maxdifference > 0.0130 && maxdifference <= 0.0290) zoomvalue='14'; //zoom 14
	else if(maxdifference > 0.0290 && maxdifference <= 0.0550) zoomvalue='13'; //zoom 13
	else if(maxdifference > 0.0550 && maxdifference <= 0.1200) zoomvalue='12'; //zoom 12
	else if(maxdifference > 0.1200 && maxdifference <= 0.4640) zoomvalue='10'; //zoom 10
	else if(maxdifference > 0.4640 && maxdifference <= 1.8580) zoomvalue='8';  //zoom 8
	else if(maxdifference > 1.8580 && maxdifference <= 3.5310) zoomvalue='7';  //zoom 7
	else if(maxdifference > 3.5310 && maxdifference <= 7.3367) zoomvalue='6';  //zoom 6
	else if(maxdifference > 7.3367 && maxdifference <= 14.222) zoomvalue='5';  //zoom 5
	else if(maxdifference > 14.222 && maxdifference <= 28.000) zoomvalue='4';  //zoom 4
	else if(maxdifference > 28.000 && maxdifference <= 58.000) zoomvalue='3';  //zoom 3
	else                                                       zoomvalue='1';  //zoom 1
	return zoomvalue;//latitudeMid+'|'+longitudeMid+'|'+zoomvalue;
}
//----------------------------------------------------------------------------------------------------
getDistanceFromLatLonInKm_HTML(lat1,lon1,lat2,lon2) {
  if(lat1===null || (typeof lat1 === "undefined") || lat1==="" || lon1===null || (typeof lon1 === "undefined") || lon1===""){return "";}
  if(lat2===null || (typeof lat2 === "undefined") || lat2==="" || lon2===null || (typeof lon2 === "undefined") || lon2===""){return "";}

  if(localStorage.getItem("lang")==="en"){ return this.getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) + " Km";}
  else                                   { return this.getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) + " Χμ";}
}
//----------------------------------------------------------------------------------------------------
getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
    var dLon = this.deg2rad(lon2-lon1);
    var a =
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon/2) * Math.sin(dLon/2)
      ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    var d = R * c; // Distance in km
    return parseFloat(d.toFixed(2));
  }
  //----------------------------------------------------------------------------------------------------
  deg2rad(deg) {
    return deg * (Math.PI/180)
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="textField1"){
      this.setState({
        "textField1"          : eventTMP,
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  dialogS_handleOpen(dialog_msg){
    this.setState({
      "dialogS_isOpen" : true,
      "dialogS_msg"    : dialog_msg
    });
  }
  dialogS_handleClose_nearest(){
    this.setState({
      "textField1_hasError" : false,
      "searchNearest"       : true,
      "searchAddress"       : false,
      "dialogS_isOpen"      : false,
    });
    setTimeout(function() {
      this.StoreLocator_btn_search();
    }.bind(this), 100);
  }
  dialogS_handleClose_newSearch(){
    this.setState({
      "searchNearest"  : false,
      "searchAddress"  : false,
      "dialogS_isOpen" : false,
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog2_handleOpen(dialog2_msg){
    this.setState({
      "dialog2_isOpen" : true,
      "dialog2_msg"    : dialog2_msg
    });
    this.setState({ "showingInfoWindow": false });
  }
  dialog2_handleClose(){
    this.setState({ "dialog2_isOpen": false });
    this.setState({ "showingInfoWindow": false });
  }
  //----------------------------------------------------------------------------------------------------
  dialog3_handleOpen(dialog3_msg){
    this.setState({
      "dialog3_isOpen" : true,
      "dialog3_msg"    : dialog3_msg
    });
  }
  dialog3_handleClose(){
    this.setState({ "dialog3_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups checkAppVersion----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_checkAppVersion_isOpen" : true,
        "dialog_checkAppVersion_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_btn_ok(){
    window.location.reload(true);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_term(event,value) {
    let methName = filename+"handleCustomDropDownClick_term ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}

    console.log(methName+eventTMP);
    if(eventTMP.length>=AUTOCOMPLETE_MIN_CHARACTERS_OPEN_POPUP){
      this.setState({"textField1_inputValue":eventTMP});
      this.setState({"textField1_popoverOpen":true});
      this.setState({"textField1_hasError":false});
      this.setState({"textField1b_hasError":false});
      this.setState({"textField1b_inputValue":""});
      this.setState({"searchAddress":false});
      localStorage.setItem("gpslat_address","");
      localStorage.setItem("gpslon_address","");
    }
    else{
      this.setState({"textField1_inputValue":eventTMP});
      this.setState({"textField1_popoverOpen":false});
      this.setState({"textField1_hasError":false});
      this.setState({"textField1b_hasError":false});
      this.setState({"textField1b_inputValue":""});
      this.setState({"searchAddress":false});
      localStorage.setItem("gpslat_address","");
      localStorage.setItem("gpslon_address","");
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_term_close(event,value) {
    let methName = filename+"handleCustomDropDownClick_term_close ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}

    console.log(methName+eventTMP);
    this.setState({"textField1_popoverOpen":false});
    //document.getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : ""
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_index_FromObj(obj){
    if(obj && obj.index){ return obj.index; }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_name_FromObj(obj){
    if(obj && obj.loc_name){ return obj.loc_name; }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_address_FromObj(obj){
    if(obj){
      if(localStorage.getItem("lang")==="en" && obj.addr_en){ return obj.addr_en; }
      if(localStorage.getItem("lang")!=="en" && obj.addr_el){ return obj.addr_el; }
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_postcode_FromObj(obj){
    if(obj){
      if(localStorage.getItem("lang")==="en" && obj.post_code){ return obj.post_code; }
      if(localStorage.getItem("lang")!=="en" && obj.post_code){ return obj.post_code; }
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  get_localename_FromObj(obj){
    if(obj){
      if(localStorage.getItem("lang")==="en" && obj.locale_name_en){ return obj.locale_name_en; }
      if(localStorage.getItem("lang")!=="en" && obj.locale_name_el){ return obj.locale_name_el; }
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  get_gm_latitude_FromObj(obj){
    if(obj){
      try{
        if(obj.gm_latitude){ return obj.gm_latitude+""; }
      } catch(err){
        console.log("get_gm_latitude_FromObj err="+err);
      }
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  get_gm_longitude_FromObj(obj){
    if(obj){
      try{
        if(obj.gm_longitude){ return obj.gm_longitude+""; }
      } catch(err){
        console.log("get_gm_longitude_FromObj err="+err);
      }
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  get_timetable_FromObj(obj){
    if(obj){
      if(localStorage.getItem("lang")==="en" && obj.timetableEN){ return obj.timetableEN; }
      if(localStorage.getItem("lang")!=="en" && obj.timetableEL){ return obj.timetableEL; }
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_isOpenNow_FromObj(obj){
    return wu_Utilities.timetableFiltering(obj,"openNow");
  }
  get_isOpenNow_FromObj_Color(obj){
    if(wu_Utilities.timetableFiltering(obj,"openNow")===true){return "green";}
    else                                                     {return "red";}
  }
  //----------------------------------------------------------------------------------------------------
  get_phone_FromObj(obj){
    if(obj && obj.tel){
      let tel = obj.tel;
      if(tel.indexOf(",")>=0){tel = tel.substring(0, tel.indexOf(","));}
      if(tel.indexOf("-")>=0){tel = tel.substring(0, tel.indexOf("-"));}
      return tel;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  show_WU_image(obj){
    if(obj && obj.loc_Services){
      let WU_Index = obj.loc_Services.indexOf("WU");
      if(WU_Index>=0){ return true; }
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  show_GC_image(obj){
    if(obj && obj.loc_Services){
      let BP_Index = obj.loc_Services.indexOf("BP");
      if(BP_Index>=0){ return true; }
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  canPayBill(obj){
    if(obj && obj.loc_Services){
      let BP_Index = obj.loc_Services.indexOf("BP");
      if(BP_Index>=0){ return true; }
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  canTransferWU(obj){
    if(obj && obj.loc_Services){
      let WU_Index = obj.loc_Services.indexOf("WU");
      if(WU_Index>=0){ return true; }
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  updateParentInitialLatLon(lat,lon) {
    //console.log("updateParentInitialLatLon lat="+lat+",lon="+lon);
    this.setState({
      initialCenter_lat : lat,
      initialCenter_lon : lon,
    });
  }
  updateParentInitialLatLonZoom(lat,lon,zoom) {
    //console.log("updateParentInitialLatLonZoom lat="+lat+",lon="+lon);
    this.setState({
      initialCenter_lat : lat,
      initialCenter_lon : lon,
      initialZoom       : zoom,
    });
  }
  update_showingInfoWindow(showingInfoWindow) {
    //let methName = filename+"update_showingInfoWindow ";
    //console.log(methName+"showingInfoWindow="+showingInfoWindow);
    this.setState({
      showingInfoWindow : showingInfoWindow,
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[FAB]---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  fab_Click2CallAction(){
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.dialog100_handleOpen(""); }
    else                                      { window.open(api.helpdeskURL, "Live Support", "toolbar=0,status=0,width=548,height=325"); }
  }
  dialog100_handleOpen(dialog_msg){
    this.setState({ "dialog100_isOpen" : true });
    this.setState({ "dialog100_msg"    : dialog_msg });
  }
  dialog100_handleClose(){
    this.setState({ "dialog100_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[CAMPAIGN]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog101_handleOpen(dialog_msg){
    this.setState({ "dialog101_isOpen" : true });
    this.setState({ "dialog101_msg"    : dialog_msg });
  }
  dialog101_handleClose(){
    this.setState({ "dialog101_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[COOKIES]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_transfer_cookies(){
    let methName = filename+"clear_cardpayment_transfer_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
    //try{ Cookies.remove('platform',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    //try{ Cookies.remove('platform',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_bill_cookies(){
    let methName = filename+"clear_cardpayment_bill_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[GoogleMapsAutocomplete]--------------------------
  //----------------------------------------------------------------------------------------------------
  GoogleMapsAutocomplete_handleClick(place){
    //let methName = filename+"GoogleMapsAutocomplete_handleClick ";
    //console.log(methName,place);

    if(place.lat!==null && place.lng!==null){
      localStorage.setItem("gpslat_address",""+place.lat); //console.log(methName+"lat="+place.lat);
      localStorage.setItem("gpslon_address",""+place.lng); //console.log(methName+"lon="+place.lng);
      this.setState({"searchAddress":true,});
      this.setState({"textField1b_hasError":false,});
    }
    else{
      localStorage.setItem("gpslat_address",""); //console.log(methName+"lat="+place.lat);
      localStorage.setItem("gpslon_address",""); //console.log(methName+"lon="+place.lng);
      this.setState({"searchAddress":false,});
    }
  }
  //----------------------------------------------------------------------------------------------------
  GoogleMapsAutocomplete_onInputChange(newText){
    //let methName = filename+"GoogleMapsAutocomplete_onInputChange ";
    //console.log(methName,newText);

    this.setState({"textField1b_inputValue":newText,});
    this.setState({"textField1b_hasError":false,});
    this.setState({"textField1_inputValue":""});
    this.setState({"textField1_hasError":false});
    this.setState({"textField1_popoverOpen":false});
  }
  //----------------------------------------------------------------------------------------------------
  getCompactDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      return `${year}${month}${day}${hours}${minutes}${seconds}`; // Example: 20250125123045
  }
  //----------------------------------------------------------------------------------------------------
}
StoreLocator.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(StoreLocatorStyle)(StoreLocator)
);
